import Box from '@mui/material/Box';
import LinearProgress from '@mui/material/LinearProgress';

/** O que aparece enquanto uma página carrega: uma linha fina no topo, nada de spinner no meio. */
export function LoadingScreen() {
  return (
    <Box sx={{ minHeight: '60vh' }} aria-busy="true" aria-label="Carregando">
      <LinearProgress sx={{ height: 3 }} />
    </Box>
  );
}
